import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';

// تنسيق العملة
const formatCurrencyValue = (value, isArabic) => {
  const num = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value || 0);
  return num + ' د.ع';
};

// دالة لإنشاء قسم الشعار والعنوان
const createHeaderSection = (shopInfo, reportTypeName, isArabic) => {
  const hasLogo = shopInfo.shop_logo && shopInfo.shop_logo.startsWith('data:');
  
  if (hasLogo) {
    return `
      <div style="text-align: center; margin-bottom: 30px; background: linear-gradient(135deg, #10b981, #059669); padding: 30px; border-radius: 15px; color: white;">
        <div style="display: flex; align-items: center; justify-content: center; gap: 20px; flex-wrap: wrap;">
          <img src="${shopInfo.shop_logo}" alt="Shop Logo" style="width: 80px; height: 80px; border-radius: 12px; object-fit: contain; background: white; padding: 8px;" />
          <div>
            <h1 style="margin: 0; font-size: 28px; font-weight: bold;">${shopInfo.shop_name || 'Nazario-Hesabaty'}</h1>
            ${shopInfo.phone ? `<p style="margin: 8px 0 0 0; font-size: 14px; opacity: 0.9;">${shopInfo.phone}</p>` : ''}
            ${shopInfo.address ? `<p style="margin: 5px 0 0 0; font-size: 12px; opacity: 0.8;">${shopInfo.address}</p>` : ''}
          </div>
        </div>
        <p style="margin: 15px 0 0 0; font-size: 16px; opacity: 0.95; border-top: 1px solid rgba(255,255,255,0.3); padding-top: 15px;">${reportTypeName}</p>
      </div>
    `;
  }
  
  return `
    <div style="text-align: center; margin-bottom: 30px; background: linear-gradient(135deg, #10b981, #059669); padding: 30px; border-radius: 15px; color: white;">
      <h1 style="margin: 0; font-size: 28px; font-weight: bold;">${shopInfo.shop_name || 'Nazario-Hesabaty'}</h1>
      ${shopInfo.phone ? `<p style="margin: 8px 0 0 0; font-size: 14px; opacity: 0.9;">${shopInfo.phone}</p>` : ''}
      ${shopInfo.address ? `<p style="margin: 5px 0 0 0; font-size: 12px; opacity: 0.8;">${shopInfo.address}</p>` : ''}
      <p style="margin: 15px 0 0 0; font-size: 16px; opacity: 0.95; border-top: 1px solid rgba(255,255,255,0.3); padding-top: 15px;">${reportTypeName}</p>
    </div>
  `;
};

// دالة تصدير التقرير كـ PDF
export const exportReportToPDF = async (report, reportType, reportId, language = "ar", shopInfo = {}) => {
  const isArabic = language === "ar";
  
  // إنشاء عنصر HTML مؤقت للتقرير - حجم A4: 210mm × 297mm
  const reportElement = document.createElement('div');
  reportElement.style.cssText = `
    position: absolute;
    left: -9999px;
    top: -9999px;
    width: 210mm;
    min-height: 297mm;
    padding: 15mm 20mm;
    background: white;
    font-family: 'Arial', 'Helvetica', sans-serif;
    direction: ${isArabic ? 'rtl' : 'ltr'};
    box-sizing: border-box;
  `;
  
  const reportTypeNames = {
    daily: isArabic ? 'Daily Report / التقرير اليومي' : 'Daily Report',
    monthly: isArabic ? 'Monthly Report / التقرير الشهري' : 'Monthly Report',
    quarterly: isArabic ? 'Quarterly Report / التقرير الربع سنوي' : 'Quarterly Report',
    yearly: isArabic ? 'Yearly Report / التقرير السنوي' : 'Yearly Report',
  };

  const now = new Date();
  const dateStr = now.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  reportElement.innerHTML = `
    ${createHeaderSection(shopInfo, reportTypeNames[reportType], isArabic)}
    
    <div style="background: #f8fafc; padding: 15px 20px; border-radius: 10px; margin-bottom: 20px; text-align: center;">
      <p style="margin: 0; color: #64748b; font-size: 12px;">Report ID / ${isArabic ? 'رقم التقرير' : 'Report ID'}</p>
      <p style="margin: 5px 0 0 0; font-size: 18px; font-weight: bold; color: #1e293b;">${reportId}</p>
    </div>
    
    <div style="display: flex; justify-content: space-between; margin-bottom: 25px; font-size: 12px; color: #64748b;">
      <span>${isArabic ? 'الفترة / Period' : 'Period'}: ${report.period || report.date || report.year || '-'}</span>
      <span>${isArabic ? 'تاريخ الإنشاء / Generated' : 'Generated'}: ${dateStr}</span>
    </div>
    
    <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px; margin-bottom: 25px;">
      <div style="background: linear-gradient(135deg, #10b981, #059669); padding: 20px; border-radius: 12px; color: white;">
        <p style="margin: 0; font-size: 11px; opacity: 0.8;">${isArabic ? 'المبيعات / Sales' : 'Total Sales'}</p>
        <p style="margin: 8px 0 0 0; font-size: 22px; font-weight: bold;">${formatCurrencyValue(report.total_sales)}</p>
      </div>
      <div style="background: linear-gradient(135deg, #f59e0b, #d97706); padding: 20px; border-radius: 12px; color: white;">
        <p style="margin: 0; font-size: 11px; opacity: 0.8;">${isArabic ? 'المشتريات / Purchases' : 'Total Purchases'}</p>
        <p style="margin: 8px 0 0 0; font-size: 22px; font-weight: bold;">${formatCurrencyValue(report.total_purchases)}</p>
      </div>
      <div style="background: linear-gradient(135deg, #3b82f6, #2563eb); padding: 20px; border-radius: 12px; color: white;">
        <p style="margin: 0; font-size: 11px; opacity: 0.8;">${isArabic ? 'المصاريف / Expenses' : 'Total Expenses'}</p>
        <p style="margin: 8px 0 0 0; font-size: 22px; font-weight: bold;">${formatCurrencyValue(report.total_expenses)}</p>
      </div>
      <div style="background: linear-gradient(135deg, ${report.net_profit >= 0 ? '#22c55e, #16a34a' : '#ef4444, #dc2626'}); padding: 20px; border-radius: 12px; color: white;">
        <p style="margin: 0; font-size: 11px; opacity: 0.8;">${isArabic ? 'صافي الربح / Net Profit' : 'Net Profit'}</p>
        <p style="margin: 8px 0 0 0; font-size: 22px; font-weight: bold;">${formatCurrencyValue(report.net_profit)}</p>
      </div>
      ${report.damages_count !== undefined ? `
      <div style="background: linear-gradient(135deg, #ef4444, #dc2626); padding: 20px; border-radius: 12px; color: white;">
        <p style="margin: 0; font-size: 11px; opacity: 0.8;">${isArabic ? 'التالفات / Damages' : 'Damages'}</p>
        <p style="margin: 8px 0 0 0; font-size: 22px; font-weight: bold;">${formatCurrencyValue(report.damages_value)} (${report.damages_count})</p>
      </div>
      ` : ''}
    </div>
    
    ${report.sales_by_payment ? `
    <div style="margin-bottom: 25px;">
      <h3 style="font-size: 14px; color: #1e293b; margin-bottom: 10px; border-bottom: 2px solid #10b981; padding-bottom: 5px;">
        ${isArabic ? 'المبيعات حسب طريقة الدفع / Sales by Payment' : 'Sales by Payment Method'}
      </h3>
      <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
        <tr style="background: #f1f5f9;">
          <td style="padding: 10px; border: 1px solid #e2e8f0;">${isArabic ? 'نقدي / Cash' : 'Cash'}</td>
          <td style="padding: 10px; border: 1px solid #e2e8f0; font-weight: bold; color: #10b981;">${formatCurrencyValue(report.sales_by_payment?.cash)}</td>
        </tr>
        <tr>
          <td style="padding: 10px; border: 1px solid #e2e8f0;">${isArabic ? 'آجل / Credit' : 'Credit'}</td>
          <td style="padding: 10px; border: 1px solid #e2e8f0; font-weight: bold; color: #f59e0b;">${formatCurrencyValue(report.sales_by_payment?.credit)}</td>
        </tr>
      </table>
    </div>
    ` : ''}
    
    <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e2e8f0; color: #94a3b8; font-size: 10px;">
      <p style="margin: 0;">Generated by Nazario-Hesabaty</p>
      <p style="margin: 5px 0 0 0;">${dateStr}</p>
    </div>
  `;
  
  document.body.appendChild(reportElement);
  
  try {
    // تحويل HTML إلى canvas
    const canvas = await html2canvas(reportElement, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff'
    });
    
    // إنشاء PDF
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });
    
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    
    // حساب أبعاد الصورة
    const imgWidth = pageWidth - 20;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
    // إضافة الصورة للـ PDF
    const imgData = canvas.toDataURL('image/png');
    doc.addImage(imgData, 'PNG', 10, 10, imgWidth, Math.min(imgHeight, pageHeight - 20));
    
    // حفظ الملف
    const fileName = `${reportTypeNames[reportType].replace(/[^\w\s]/gi, '')}_${reportId}.pdf`;
    doc.save(fileName);
    
  } finally {
    // إزالة العنصر المؤقت
    document.body.removeChild(reportElement);
  }
};

// دالة تصدير جدول الديون كـ PDF
export const exportDebtsToPDF = async (debts, totals, language = "ar", shopInfo = {}) => {
  const isArabic = language === "ar";
  
  // إعدادات A4 للتقرير
  const reportElement = document.createElement('div');
  reportElement.style.cssText = `
    position: absolute;
    left: -9999px;
    top: -9999px;
    width: 210mm;
    min-height: 297mm;
    padding: 15mm 20mm;
    background: white;
    font-family: 'Arial', 'Helvetica', sans-serif;
    direction: ${isArabic ? 'rtl' : 'ltr'};
    box-sizing: border-box;
  `;
  
  const now = new Date();
  const dateStr = now.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  
  let debtsRows = '';
  debts.slice(0, 20).forEach((debt, i) => {
    debtsRows += `
      <tr style="background: ${i % 2 === 0 ? '#f8fafc' : 'white'};">
        <td style="padding: 10px; border: 1px solid #e2e8f0;">${debt.customer_name}</td>
        <td style="padding: 10px; border: 1px solid #e2e8f0;">${debt.customer_phone || '-'}</td>
        <td style="padding: 10px; border: 1px solid #e2e8f0; color: #ef4444; font-weight: bold;">${formatCurrencyValue(debt.total_debt)}</td>
      </tr>
    `;
  });
  
  reportElement.innerHTML = `
    ${createHeaderSection(shopInfo, isArabic ? 'Customer Debts Report / تقرير ديون الزبائن' : 'Customer Debts Report', isArabic)}
    
    <div style="display: flex; justify-content: space-between; margin-bottom: 20px; font-size: 12px; color: #64748b;">
      <span>${isArabic ? 'التاريخ / Date' : 'Date'}: ${dateStr}</span>
      <span>${isArabic ? 'العدد / Total' : 'Total'}: ${debts.length} ${isArabic ? 'زبون / customers' : 'customers'}</span>
    </div>
    
    <div style="background: linear-gradient(135deg, #ef4444, #dc2626); padding: 20px; border-radius: 12px; color: white; margin-bottom: 20px; text-align: center;">
      <p style="margin: 0; font-size: 12px; opacity: 0.8;">${isArabic ? 'إجمالي الديون / Total Debts' : 'Total Debts'}</p>
      <p style="margin: 8px 0 0 0; font-size: 28px; font-weight: bold;">${formatCurrencyValue(totals?.totalDebt || debts.reduce((sum, d) => sum + (d.total_debt || 0), 0))}</p>
    </div>
    
    <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
      <thead>
        <tr style="background: #1e293b; color: white;">
          <th style="padding: 12px; border: 1px solid #334155; text-align: ${isArabic ? 'right' : 'left'};">${isArabic ? 'الزبون / Customer' : 'Customer'}</th>
          <th style="padding: 12px; border: 1px solid #334155; text-align: ${isArabic ? 'right' : 'left'};">${isArabic ? 'الهاتف / Phone' : 'Phone'}</th>
          <th style="padding: 12px; border: 1px solid #334155; text-align: ${isArabic ? 'right' : 'left'};">${isArabic ? 'الدين / Debt' : 'Debt'}</th>
        </tr>
      </thead>
      <tbody>
        ${debtsRows}
      </tbody>
    </table>
    
    ${debts.length > 20 ? `<p style="text-align: center; color: #64748b; font-size: 11px; margin-top: 10px;">... ${isArabic ? `و ${debts.length - 20} آخرين / and ${debts.length - 20} more` : `and ${debts.length - 20} more`}</p>` : ''}
    
    <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #e2e8f0; color: #94a3b8; font-size: 10px;">
      <p style="margin: 0;">Generated by Nazario-Hesabaty</p>
    </div>
  `;
  
  document.body.appendChild(reportElement);
  
  try {
    const canvas = await html2canvas(reportElement, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff'
    });
    
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });
    
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const imgWidth = pageWidth - 20;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
    const imgData = canvas.toDataURL('image/png');
    doc.addImage(imgData, 'PNG', 10, 10, imgWidth, Math.min(imgHeight, pageHeight - 20));
    
    const fileName = isArabic ? 'Customer_Debts_Report.pdf' : 'Customer_Debts_Report.pdf';
    doc.save(fileName);
    
  } finally {
    document.body.removeChild(reportElement);
  }
};

// دالة تصدير الوصل كـ PDF
export const exportReceiptToPDF = async (sale, shopInfo = {}, language = "ar") => {
  const isArabic = language === "ar";
  const hasLogo = shopInfo.shop_logo && shopInfo.shop_logo.startsWith('data:');
  
  const reportElement = document.createElement('div');
  reportElement.style.cssText = `
    position: absolute;
    left: -9999px;
    top: -9999px;
    width: 400px;
    padding: 30px;
    background: white;
    font-family: 'Arial', 'Helvetica', sans-serif;
    direction: ${isArabic ? 'rtl' : 'ltr'};
  `;
  
  const saleDate = sale.created_at ? new Date(sale.created_at).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }) : '-';
  
  let itemsRows = '';
  (sale.items || []).forEach((item, i) => {
    itemsRows += `
      <tr style="background: ${i % 2 === 0 ? '#f8fafc' : 'white'};">
        <td style="padding: 8px; border-bottom: 1px solid #e2e8f0; font-size: 11px;">${item.product_name}</td>
        <td style="padding: 8px; border-bottom: 1px solid #e2e8f0; font-size: 11px; text-align: center;">${item.quantity}</td>
        <td style="padding: 8px; border-bottom: 1px solid #e2e8f0; font-size: 11px; text-align: center;">${formatCurrencyValue(item.price)}</td>
        <td style="padding: 8px; border-bottom: 1px solid #e2e8f0; font-size: 11px; text-align: center; font-weight: bold;">${formatCurrencyValue(item.total)}</td>
      </tr>
    `;
  });
  
  reportElement.innerHTML = `
    <div style="text-align: center; margin-bottom: 20px; padding-bottom: 15px; border-bottom: 2px dashed #e2e8f0;">
      ${hasLogo ? `
        <img src="${shopInfo.shop_logo}" alt="Logo" style="width: 60px; height: 60px; border-radius: 8px; object-fit: contain; margin-bottom: 10px;" />
      ` : ''}
      <h1 style="margin: 0; font-size: 20px; font-weight: bold; color: #10b981;">${shopInfo.shop_name || 'Nazario-Hesabaty'}</h1>
      ${shopInfo.phone ? `<p style="margin: 3px 0 0 0; font-size: 11px; color: #64748b;">${shopInfo.phone}</p>` : ''}
      ${shopInfo.address ? `<p style="margin: 3px 0 0 0; font-size: 10px; color: #94a3b8;">${shopInfo.address}</p>` : ''}
    </div>
    
    <div style="margin-bottom: 15px; font-size: 11px; color: #64748b;">
      <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
        <span>${isArabic ? 'Receipt # / وصل رقم' : 'Receipt #'}</span>
        <span style="font-weight: bold; color: #1e293b;">${sale.id?.slice(0, 8) || '-'}</span>
      </div>
      <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
        <span>${isArabic ? 'Date / التاريخ' : 'Date'}</span>
        <span>${saleDate}</span>
      </div>
      ${sale.customer_name ? `
      <div style="display: flex; justify-content: space-between;">
        <span>${isArabic ? 'Customer / الزبون' : 'Customer'}</span>
        <span>${sale.customer_name}</span>
      </div>
      ` : ''}
    </div>
    
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;">
      <thead>
        <tr style="background: #1e293b; color: white;">
          <th style="padding: 8px; font-size: 10px; text-align: ${isArabic ? 'right' : 'left'};">${isArabic ? 'Item / الصنف' : 'Item'}</th>
          <th style="padding: 8px; font-size: 10px; text-align: center;">${isArabic ? 'Qty / الكمية' : 'Qty'}</th>
          <th style="padding: 8px; font-size: 10px; text-align: center;">${isArabic ? 'Price / السعر' : 'Price'}</th>
          <th style="padding: 8px; font-size: 10px; text-align: center;">${isArabic ? 'Total / المجموع' : 'Total'}</th>
        </tr>
      </thead>
      <tbody>
        ${itemsRows}
      </tbody>
    </table>
    
    <div style="background: #f8fafc; padding: 15px; border-radius: 8px; margin-bottom: 15px;">
      <div style="display: flex; justify-content: space-between; margin-bottom: 8px; font-size: 12px;">
        <span>${isArabic ? 'Subtotal / المجموع الفرعي' : 'Subtotal'}</span>
        <span>${formatCurrencyValue(sale.subtotal || sale.total)}</span>
      </div>
      ${sale.discount ? `
      <div style="display: flex; justify-content: space-between; margin-bottom: 8px; font-size: 12px; color: #ef4444;">
        <span>${isArabic ? 'Discount / الخصم' : 'Discount'}</span>
        <span>-${formatCurrencyValue(sale.discount)}</span>
      </div>
      ` : ''}
      <div style="display: flex; justify-content: space-between; font-size: 16px; font-weight: bold; color: #10b981; padding-top: 8px; border-top: 1px solid #e2e8f0;">
        <span>${isArabic ? 'Total / الإجمالي' : 'Total'}</span>
        <span>${formatCurrencyValue(sale.total)}</span>
      </div>
    </div>
    
    <div style="display: flex; justify-content: space-between; font-size: 11px; margin-bottom: 15px;">
      <span style="padding: 5px 10px; background: ${sale.payment_type === 'cash' ? '#dcfce7' : '#fef3c7'}; border-radius: 4px; color: ${sale.payment_type === 'cash' ? '#16a34a' : '#d97706'};">
        ${sale.payment_type === 'cash' ? (isArabic ? 'Cash / نقدي' : 'Cash') : (isArabic ? 'Credit / آجل' : 'Credit')}
      </span>
      ${sale.amount_paid !== undefined ? `
      <span>${isArabic ? 'Paid / المدفوع' : 'Paid'}: ${formatCurrencyValue(sale.amount_paid)}</span>
      ` : ''}
    </div>
    
    <div style="text-align: center; padding-top: 15px; border-top: 2px dashed #e2e8f0; color: #94a3b8; font-size: 10px;">
      <p style="margin: 0;">${isArabic ? 'Thank you! / شكراً لك!' : 'Thank you!'}</p>
      <p style="margin: 5px 0 0 0;">Nazario-Hesabaty</p>
    </div>
  `;
  
  document.body.appendChild(reportElement);
  
  try {
    const canvas = await html2canvas(reportElement, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff'
    });
    
    // استخدام حجم أصغر للوصل
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [80, 200], // حجم وصل حراري
    });
    
    const pageWidth = doc.internal.pageSize.getWidth();
    const imgWidth = pageWidth - 10;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
    const imgData = canvas.toDataURL('image/png');
    doc.addImage(imgData, 'PNG', 5, 5, imgWidth, imgHeight);
    
    const fileName = `receipt_${sale.id?.slice(0, 8) || 'sale'}.pdf`;
    doc.save(fileName);
    
  } finally {
    document.body.removeChild(reportElement);
  }
};
